// REFACTOR: store this as entities and load from server
const typeIds = {
  DROPDOWN: 9,
  MULTIPLE: 5,
  ENPS: 7,
  ICON: 3,
  RATING: 2,
  YES_NO: 4,
  TEXT: 6,
  MESSAGE: 8,
};

const typeNames = {
  DROPDOWN: 'DROPDOWN',
  MULTIPLE: 'MULTIPLE',
  ENPS: 'NPS',
  ICON: 'FIXED',
  RATING: 'SLIDING',
  YES_NO: 'YES_NO',
  TEXT: 'OPEN',
  MESSAGE: 'MESSAGE',
};

const iconNames = {
  DROPDOWN: 'KeyboardArrowDown',
  MULTIPLE: 'Ballot',
  ENPS: 'NetworkCheck',
  ICON: 'Photo',
  RATING: 'StarRate',
  YES_NO: 'CheckCircleOutline',
  TEXT: 'BorderColor',
  MESSAGE: 'ChatBubbleOutline',
};

const questionTypeNames = {
  SCALE: 'scale',
  OPTION: 'option',
  TEXT: 'text',
  MESSAGE: 'message',
};

export { typeIds, typeNames, iconNames, questionTypeNames };
